/**
 * Cache simple en memoria para el servidor (SSR)
 * Evita llamadas repetidas a la API de autenticación en cada request
 */

const cache = new Map();

/**
 * Configuración de TTL por tipo de recurso
 */
const CACHE_TTL = {
  application: 30 * 60 * 1000, // 30 minutos
  default: 5 * 60 * 1000, // 5 minutos
};

/**
 * Obtiene datos del cache si están vigentes
 * @param {string} key - Clave del cache
 * @returns {any|null} Datos cacheados o null si expiró
 */
export function getCachedData(key) {
  const cached = cache.get(key);
  
  if (!cached) {
    return null;
  }
  
  const now = Date.now();
  if (now - cached.timestamp > cached.ttl) {
    cache.delete(key);
    return null;
  }
  
  return cached.data;
}

/**
 * Guarda datos en el cache
 * @param {string} key - Clave del cache
 * @param {any} data - Datos a cachear
 * @param {number} ttl - Time to live en milisegundos
 */
export function setCachedData(key, data, ttl = CACHE_TTL.default) {
  cache.set(key, {
    data,
    timestamp: Date.now(),
    ttl,
  });
}

/**
 * Limpia una entrada específica del cache
 * @param {string} key - Clave a eliminar
 */
export function clearCachedData(key) {
  cache.delete(key);
}

/**
 * Limpia todo el cache
 */
export function clearAllCache() {
  cache.clear();
}

/**
 * Obtiene estadísticas del cache
 */
export function getCacheStats() {
  const stats = {
    size: cache.size,
    entries: [],
  };
  
  cache.forEach((value, key) => {
    const age = Date.now() - value.timestamp;
    const remaining = value.ttl - age;
    stats.entries.push({
      key,
      age: Math.floor(age / 1000),
      remainingTtl: Math.floor(remaining / 1000),
      expired: remaining <= 0,
    });
  });
  
  return stats;
}

export { CACHE_TTL };
